export default __webpack_public_path__ + "static/media/5.bec514f8.jpg";